/**
 * 2021-08-18: Currently since this was just implemented, it's
 * developed for DSEC events only, but this could/should be
 * implemented for all front-end permisions eventually.
 * Follow the pattern for DSEC below. Implement contextual permissions object.
 * Add to permissions nested array/object.
 *
 * 2021-09-24: This needs to be re-implemented for asynchronous functionality.
 *
 */
import eventTrackerPermissionsMixin from "@/components/Widgets/DSEC/permissionsMixin.js";

const AmazePermissions = {};

AmazePermissions.KEY = "amaze";

AmazePermissions.isUberAdmin = ($auth, $store, data) => {
  return $auth.check("uber_admin");
}

const permissionDefinitions = {
  "administer": AmazePermissions.isUberAdmin
};

var permissions = {};
permissions[AmazePermissions.KEY] = permissionDefinitions;

export default {
  mixins: [
    eventTrackerPermissionsMixin
  ],
  created: function() {
    // console.log('AmazePermissions created', this.application_user_permissions);
  },
  data: function() {
    return {
      application_user_permissions: permissions
    }
  },
  methods: {
    // Uber admin check.
    isUberAdmin() {
      return AmazePermissions.isUberAdmin(this.$auth);
    },
    permissionExists(verb, noun, data = {}) {
      return this.application_user_permissions.hasOwnProperty(noun) &&
        this.application_user_permissions[noun].hasOwnProperty(verb);
    },
    /**
     * Can the user verb the noun?
     * Example: amazeUserCan("view", "dsec_calendar");
     *
     * @param {*} verb
     * @param {*} noun
     */
    amazeUserCan(verb, noun, data = {}) {
      // Ubs can do anything. ANYTHING.
      if (this.isUberAdmin()) {
        return true;
      }

      // Check if the permissions matrix contains the noun and the verb.
      if (this.permissionExists(verb, noun, data)) {
        return this.application_user_permissions[noun][verb](this.$auth, this.$store, data);
      }

      // Default scenario? You can't do a thing.
      return false;
    }
  }
};
